import React from 'react'
import { Checkbox } from 'streamr-ui'
import styled from 'styled-components'

export function NewsletterEmailAgreement({ checked, toggle }) {
    return (
        <NewsletterEmailAgreementRoot>
            <Label>
                <Checkbox checked={checked} onChange={toggle} />
                <div>I agree to receive marketing emails from Streamr.</div>
            </Label>
            <PrivacyNote>
                You can unsubscribe anytime. See our&nbsp;
                <span>
                    <a
                        href="https://s3.amazonaws.com/streamr-public/streamr-privacy-policy.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                    >
                        Privacy Policy
                    </a>
                </span>
                .
            </PrivacyNote>
        </NewsletterEmailAgreementRoot>
    )
}

const PrivacyNote = styled.div`
    color: #808080;
    margin-top: 0.5rem;
    padding-left: 1.375rem;
`

const Label = styled.label`
    display: flex;
    align-items: center;
`

const NewsletterEmailAgreementRoot = styled.div`
    font-size: 0.875rem;
    margin: 1.5rem 0;
    color: #323232;
`
